import { keyframes } from '@emotion/react';

const goldIconExpand = keyframes`
  from {
    transform: scaleY(0);
    opacity: 0;
  }
  to {
    transform: scaleY(1);
    opacity: 1;
  }
`;

const textFadeIn = keyframes`
  from {
    transform: translateY(20px);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const fadeOut = keyframes`
  from {
    opacity: 1;
  }
  to {
    opacity: 0;
  }
`;

export const loadingScreenStyles = (isFadingOut = false) => {
  return {
    container: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      zIndex: 9999,
      overflow: 'hidden',
      ...(isFadingOut && {
        animation: `${fadeOut} 0.5s ease-out forwards`,
      }),
    },
    video: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      objectFit: 'cover',
      zIndex: 0,
    },
    bgOverlay: {
      position: 'absolute',
      top: 0,
      left: 0,
      width: '100%',
      height: '100%',
      backgroundColor: '#00443F', // Primary color overlay
      opacity: 1, // Full opacity
      mixBlendMode: 'multiply', // Blend fully opaque color with video
      zIndex: 0.5,
    },
    contentContainer: {
      position: 'relative',
      zIndex: 2,
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      height: '100%',
    },
    goldIcon: {
      width: {xs: '149px', md: '199px', lg: '295px'},
      height: {xs: '149px', md: '199px', lg: '295px'},
      transformOrigin: 'center center',
      animation: `${goldIconExpand} 1s ease-out 1.5s both`,
    },
    loadingText: {
      width: {xs: '250px', md: '350px', lg: '660px'},
      height: {xs: '60px', md: '80px', lg: '135px'},
      marginTop:{xs: '0px', md: '25px'},
      animation: `${textFadeIn} 1s ease-out 2s both`,
    },
  };
};

